import PropTypes from 'prop-types';
import { FaCheck, FaRegStar } from 'react-icons/fa';
import LoadingAction from '../utils/LoadingAction';
import LoadingButton from '../utils/Loading';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const PricingCard = ({
  title,
  description,
  features,
  price,
  isPopular = false,
  delay = 0,
}) => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const whatsappMessage = encodeURIComponent(
    `Hi Tehzeeb, I'm interested in the ${title} plan.`
  );
  const [whatLoading, setWhatLoading] = useState(false);

  return (
    <div
      className="col-lg-4 col-md-6 mb-4"
      data-aos="fade-up"
      data-aos-delay={delay}
    >
      <div className={`pricing-card ${isPopular ? 'popular pt-4' : ''}`}>
        {isPopular && (
          <div className="popular-badge">
            <FaRegStar size={12} className="mr-1" />
            Most Popular
          </div>
        )}
        <div className="pricing-header">
          <h4 className="pricing-title">{title}</h4>
          <p className="pricing-description">{description}</p>
        </div>
        <div className="pricing-body">
          <ul className="pricing-features">
            {features.map((feature, index) => (
              <li key={index}>
                <FaCheck size={16} className="feature-icon" />
                <span>{feature}</span>
              </li>
            ))}
          </ul>
          <div className="pricing-price">
            {price}
          </div>
          <div className="pricing-buttons">
            <LoadingButton
             className="btn btn-primary rounded-pill shadow hire-btn"
             isLoading={loading}
             onClick={() => 
              LoadingAction(
                setLoading,
                () => navigate("/#contact"),
              )
             }  
            >
              Get Started
            </LoadingButton>
            <LoadingButton
              isLoading={whatLoading}
              onClick={() =>
                LoadingAction(
                  setWhatLoading,
                  () => {
                    const newWindow = window.open(
                      `https://wa.me/918982896759?text=${whatsappMessage}`, 
                      "_blank", 
                      "noopener,noreferrer"
                    );

                    if (newWindow) {
                      newWindow.opener = null
                    }
                  }
                )
              }
              className="btn btn-outline-primary rounded-pill shadow service-btn"
            >
              WhatsApp Me
            </LoadingButton>
          </div>
        </div>
      </div>
    </div>
  );
};

PricingCard.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  features: PropTypes.arrayOf(PropTypes.string).isRequired,
  price: PropTypes.string.isRequired,
  isPopular: PropTypes.bool,
  delay: PropTypes.number,
};

export default PricingCard;
